// Coppie di sezioni "Prodotti QUADRATI" da unire in una sola riga su mobile.
const HOME_PRODUCTS_SECTION_PAIRS = [
  ['section_YLUeWa', 'section_xeh7zY'],
  ['section_rrc64n', 'section_8fK66t'],
];

// Breakpoint mobile del tema.
const MOBILE_BREAKPOINT = '(max-width: 749px)';
const HOME_TEMPLATE = 'index';
const HOME_HERO_CARDS_SECTION_ID_SUFFIXES = ['hero_mfhn4A'];
const HOME_HERO_CARDS_KEY_PATHS = [
  '/pages/produzione-piante',
  '/pages/laboratorio',
  '/pages/appartamenti-zilius',
  '/collections/appartamenti-zilius',
  '/pages/agrivoltaico',
  '/collections/agrivoltaico',
];
const HOME_HERO_CARDS_TAG_CLASS = 'mobile-home-hero-cards-rail';
const PAGE_MENU_HERO_CARDS_TAG_CLASS = 'mobile-page-menu-hero-cards-rail';
const PAGE_MENU_RAIL_TEMPLATES = [
  'page.agrivoltaico',
  'page.laboratorio',
  'page.miele',
  'page.mirtillo',
  'page.oliva',
  'page.produzione-piante',
];
const MIRTILLO_PAGE_TEMPLATE = 'page.mirtillo';
const MIRTILLO_MEDIA_GALLERY_SECTION_ID = 'media_card_gallery_piu_mirtillo';
const MIRTILLO_MEDIA_GALLERY_TAG_CLASS = 'mobile-mirtillo-image-carousel';
const MIRTILLO_TOP_COLLECTIONS_TAG_CLASS = 'mobile-mirtillo-top-collections';
const MIRTILLO_MULTICOLUMN_SECTION_IDS = ['section_zaQt9f', 'section_MmGgck', 'section_XY4xmi'];
const MIRTILLO_MULTICOLUMN_TAG_CLASS = 'mobile-mirtillo-multicolumn-rail';
const MIELE_PAGE_TEMPLATE = 'page.miele';
const MIELE_MULTICOLUMN_SECTION_IDS = ['section_UGLFfj', 'section_jygFFa', 'section_BAGfyz'];
const MIELE_MULTICOLUMN_TAG_CLASS = 'mobile-miele-multicolumn-rail';
const OLIVA_PAGE_TEMPLATE = 'page.oliva';
const OLIVA_MULTICOLUMN_SECTION_IDS = ['section_UGLFfj', 'section_jygFFa', 'section_BAGfyz'];
const OLIVA_MULTICOLUMN_TAG_CLASS = 'mobile-oliva-multicolumn-rail';
const AGRIVOLTAICO_PAGE_TEMPLATE = 'page.agrivoltaico';
const AGRIVOLTAICO_MULTICOLUMN_SECTION_IDS = ['section_UGLFfj', 'section_gBADpD', 'section_BAGfyz'];
const AGRIVOLTAICO_MULTICOLUMN_TAG_CLASS = 'mobile-agrivoltaico-multicolumn-rail';
const AGRIVOLTAICO_HOME_PAGE_TEMPLATE = 'page.agrivoltaico-home';
const AGRIVOLTAICO_HOME_QUADRATI_SECTION_IDS = ['section_mmaNK9'];
const AGRIVOLTAICO_HOME_QUADRATI_TAG_CLASS = 'mobile-agrivoltaico-home-quadrati-rail';
const LABORATORIO_PAGE_TEMPLATE = 'page.laboratorio';
const LABORATORIO_QUADRATI_SECTION_IDS = ['section_CtJCnm'];
const LABORATORIO_QUADRATI_TAG_CLASS = 'mobile-laboratorio-quadrati-rail';
const PRODUZIONE_PIANTE_PAGE_TEMPLATE = 'page.produzione-piante';
const PRODUZIONE_PIANTE_QUADRATI_SECTION_IDS = ['section_R8G4tz'];
const PRODUZIONE_PIANTE_QUADRATI_TAG_CLASS = 'mobile-produzione-piante-quadrati-rail';
const APPARTAMENTI_PAGE_TEMPLATE = 'page.appartamenti-zilius';
const APPARTAMENTI_QUADRATI_SECTION_IDS = ['section_6jzd3N'];
const APPARTAMENTI_QUADRATI_TAG_CLASS = 'mobile-appartamenti-quadrati-rail';
const SHOP_PAGE_TEMPLATES = ['page.prodotti'];
const SHOP_PAGE_PATHS = ['/pages/prodotti'];
const SHOP_MULTICOLUMN_SECTION_IDS = ['section_fTMezc'];
const SHOP_MULTICOLUMN_TAG_CLASS = 'mobile-shop-multicolumn-rail';
const SHOP_PRODUCT_LIST_TAG_CLASS = 'mobile-shop-product-list-single';
const SHOP_FILTER_CATEGORIES = ['mirtillo', 'miele', 'olio', 'box'];
const SHOP_FILTER_LABELS = { mirtillo: 'Prodotti al mirtillo', miele: 'Prodotti di miele', olio: 'Prodotti di olio', inactive: 'Prossimamente', box: 'Box e confezioni' };
const SHOP_FILTER_TRIGGER_ORDER = ['mirtillo', 'miele', 'olio', 'inactive', 'box'];
const SHOP_FILTER_PRODUCTS_SECTION_ID = 'section_rCDtGR';
const SHOP_FILTER_TRIGGER_CLASS = 'shop-filter-trigger';
const SHOP_FILTER_ITEM_CLASS = 'shop-filter-item';
const SHOP_FILTER_HIDDEN_CLASS = 'is-shop-filter-hidden';
const SHOP_FILTER_MATCH_CLASS = 'is-shop-filter-match';
const SHOP_FILTER_ANIMATING_CLASS = 'is-shop-filter-animating';
const SHOP_FILTER_ACTIVE_CLASS = 'is-shop-filter-active';
const SHOP_FILTER_DIMMED_CLASS = 'is-shop-filter-dimmed';
const SHOP_FILTER_TRACK_ACTIVE_CLASS = 'is-shop-filtered';
const SHOP_FILTER_BOUND_ATTR = 'data-shop-filter-bound';
const AUTO_COLUMN_RAIL_TAG_CLASS = 'mobile-auto-column-rail';
const AUTO_COLUMN_TRACK_CLASS = 'mobile-auto-column-track';
const AUTO_COLUMN_CONTROLS_CLASS = 'mobile-auto-column-controls';
const AUTO_COLUMN_DOT_CLASS = 'mobile-auto-column-dot';
const GIN_MIRTILLO_DETAILS_SECTION_ID = 'section_XtegxP';
const AUTO_COLUMN_AUTOPLAY_INTERVAL_MS = 4200;
const AUTO_COLUMN_AUTOPLAY_RESUME_DELAY_MS = 6500;
const AUTO_COLUMN_VISIBILITY_THRESHOLD = 0.55;
const PRODUCT_NUTRITION_TEXT_SELECTOR = '#MainContent[data-template*="product"] .text-block';
const PRODUCT_NUTRITION_LABELS = [
  'di cui Acidi Grassi Monosaturi',
  'di cui Acidi Grassi Polinsaturi',
  'di cui Acidi Grassi Saturi',
  'di cui Zuccheri',
  'Vitamina E',
  'Carboidrati',
  'Proteine',
  'Energia',
  'Grassi',
  'Sale',
];
const HOME_PRODUCTS_SECTION_IDS = HOME_PRODUCTS_SECTION_PAIRS.flat();

// Taglia immagine usata su mobile per evitare immagini sgranate quando le card sono full-width.
const MOBILE_IMAGE_SIZES = '(max-width: 749px) calc(100vw - 24px), 100vw';
const MOBILE_HERO_CARD_IMAGE_SIZES = '(max-width: 749px) min(66vw, 250px), 250px';
const MOBILE_COMPACT_PAGE_MENU_IMAGE_SIZES = '(max-width: 749px) min(38vw, 140px), 140px';
const HOME_PRODUCTS_AUTOPLAY_INTERVAL_MS = 4200;
const HOME_PRODUCTS_AUTOPLAY_RESUME_DELAY_MS = 6500;

const HERO_MENU_ACTIVE_ALIGN_TOLERANCE_PX = 2;
const autoColumnRailControllers = new Map();
const autoColumnRailObserver =
  typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(handleAutoColumnRailIntersection, {
        threshold: [0, AUTO_COLUMN_VISIBILITY_THRESHOLD],
      })
    : null;

// Stato runtime per ripristinare il layout desktop quando serve.
const state = {
  applied: false,
  firstSection: null,
  secondSection: null,
  firstTrack: null,
  movedCards: [],
  placeholders: [],
  firstHadMobileColumn: false,
  carousel: {
    track: null,
    slides: [],
    controls: null,
    dots: [],
    activeIndex: 0,
    scrollRafId: 0,
    autoplayIntervalId: 0,
    autoplayResumeTimeoutId: 0,
    onScroll: null,
    onInteraction: null,
    onVisibilityChange: null,
  },
  heroMenuAlignRafId: 0,

  shopFilterCategory: null,
  shopFilterTimeline: null,
  shopFilterSetupRafId: 0,
  shopFilterGrid: null,
};

function getCurrentTemplateName() {
  return document.querySelector('#MainContent')?.getAttribute('data-template') ?? '';
}

function isShopTemplate() {
  const templateName = getCurrentTemplateName();
  if (SHOP_PAGE_TEMPLATES.includes(templateName)) return true;

  const pathname = window.location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
  return SHOP_PAGE_PATHS.some((path) => pathname === path || pathname.endsWith(path));
}

function isHomeTemplate() {
  const templateName = getCurrentTemplateName();
  if (templateName === HOME_TEMPLATE || templateName.startsWith(`${HOME_TEMPLATE}.`)) return true;

  const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
  return pathname === '/';
}

function shouldReduceAutomaticMotion() {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  return (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    Boolean(connection?.saveData) ||
    Number(navigator.hardwareConcurrency) <= 2 ||
    Number(navigator.deviceMemory) <= 2
  );
}

function isElementInViewport(element) {
  if (!(element instanceof Element)) return false;
  const rect = element.getBoundingClientRect();
  return rect.bottom > 0 && rect.top < window.innerHeight;
}

// Marca l'ultima sezione collection-list della home per applicare il CSS dedicato al carosello finale.
function markBottomHomeCollectionCarousel() {
  const markedSections = document.querySelectorAll('.mobile-home-bottom-collections');
  for (const section of markedSections) {
    section.classList.remove('mobile-home-bottom-collections');
  }

  if (!isHomeTemplate()) return;

  const collectionSections = Array.from(document.querySelectorAll('.shopify-section')).filter((section) =>
    section.querySelector('[data-testid="collection-list"]'),
  );

  const bottomCollectionSection = collectionSections[collectionSections.length - 1];
  if (bottomCollectionSection) {
    bottomCollectionSection.classList.add('mobile-home-bottom-collections');
  }
}

function normalizePathFromHref(href) {
  if (!href) return '';

  try {
    const url = new URL(href, window.location.origin);
    const normalizedPath = url.pathname.toLowerCase().replace(/\/+$/, '');
    return normalizedPath || '/';
  } catch {
    return '';
  }
}

function isHeroMenuPathActive(linkPathname, currentPathname) {
  if (!linkPathname || !currentPathname) return false;

  const relatedPaths = new Set([linkPathname]);

  if (linkPathname.startsWith('/pages/')) {
    relatedPaths.add(`/collections/${linkPathname.slice('/pages/'.length)}`);
  } else if (linkPathname.startsWith('/collections/')) {
    relatedPaths.add(`/pages/${linkPathname.slice('/collections/'.length)}`);
  }

  for (const path of relatedPaths) {
    if (path === '/') {
      if (currentPathname === '/') return true;
      continue;
    }

    if (currentPathname === path || currentPathname.startsWith(`${path}/`)) {
      return true;
    }
  }

  return false;
}

function isPageMenuRailTemplate() {
  const templateName = getCurrentTemplateName();
  if (templateName === 'page' || templateName.startsWith('page.')) return true;
  return PAGE_MENU_RAIL_TEMPLATES.includes(templateName) || isShopTemplate();
}

function getHeroGroupCardsTrack(section) {
  if (!(section instanceof HTMLElement)) return null;

  const track = section.querySelector('.hero__content-wrapper > .group-block > .group-block-content');
  return track instanceof HTMLElement ? track : null;
}

function getHeroGroupCards(track) {
  if (!(track instanceof HTMLElement)) return [];

  return Array.from(track.children).filter(
    (child) => child instanceof HTMLElement && child.classList.contains('group-block'),
  );
}

function isHomeHeroCardsSectionCandidate(section) {
  if (!(section instanceof HTMLElement)) return false;

  const track = getHeroGroupCardsTrack(section);
  if (!track) return false;

  const cards = getHeroGroupCards(track);
  if (cards.length < 4) return false;

  const hasImageAndTextCards = cards.every(
    (card) => card.querySelector('.image-block') && card.querySelector('.text-block'),
  );

  if (!hasImageAndTextCards) return false;

  const matchedPaths = new Set();

  for (const card of cards) {
    const links = card.querySelectorAll('a[href]');

    for (const link of links) {
      const href = link.getAttribute('href');
      const pathname = normalizePathFromHref(href);

      if (!pathname) continue;

      const matchedPath = HOME_HERO_CARDS_KEY_PATHS.find((path) => pathname.includes(path));
      if (matchedPath) {
        matchedPaths.add(matchedPath);
      }
    }
  }

  return matchedPaths.size >= 2;
}

function isPageMenuHeroCardsSectionCandidate(section) {
  const track = getHeroGroupCardsTrack(section);
  if (!track) return false;

  const cards = getHeroGroupCards(track);
  if (cards.length < 3) return false;

  const hasImageCards = cards.every((card) => card.querySelector('.image-block'));
  if (!hasImageCards) return false;

  const linkedCardsCount = cards.filter((card) => card.querySelector('a[href]')).length;
  const filterCardsCount = cards.filter((card) => card.classList.contains(SHOP_FILTER_TRIGGER_CLASS)).length;
  const shopIconCardsCount = cards.filter((card) =>
    card.querySelector('img[src*="Tasti-icone"], img[src*="shop-menu"], img[alt*="Tasti"]'),
  ).length;
  return (
    linkedCardsCount >= Math.min(3, cards.length) ||
    filterCardsCount >= Math.min(3, cards.length) ||
    shopIconCardsCount >= Math.min(3, cards.length)
  );
}

// Marca il primo hero della home con card immagini a gruppi per forzare rail orizzontale su mobile.
function markHomeHeroCardsRail() {
  const taggedSections = document.querySelectorAll(`.${HOME_HERO_CARDS_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(HOME_HERO_CARDS_TAG_CLASS);
  }

  if (!isHomeTemplate()) return;

  for (const sectionId of HOME_HERO_CARDS_SECTION_ID_SUFFIXES) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(HOME_HERO_CARDS_TAG_CLASS);
      return;
    }
  }

  const heroSections = Array.from(document.querySelectorAll('.shopify-section.hero-wrapper'));
  const targetSection = heroSections.find((section) => isHomeHeroCardsSectionCandidate(section));

  if (targetSection) {
    targetSection.classList.add(HOME_HERO_CARDS_TAG_CLASS);
  }
}

// Marca il menu hero delle pagine interne per riusare la stessa rail orizzontale mobile della home.
function markPageMenuHeroCardsRail() {
  const taggedSections = document.querySelectorAll(`.${PAGE_MENU_HERO_CARDS_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(PAGE_MENU_HERO_CARDS_TAG_CLASS);
  }

  if (!isPageMenuRailTemplate()) return;

  const heroSections = Array.from(document.querySelectorAll('.shopify-section.hero-wrapper'));
  const targetSection = heroSections.find((section) => isPageMenuHeroCardsSectionCandidate(section));

  if (targetSection) {
    targetSection.classList.add(PAGE_MENU_HERO_CARDS_TAG_CLASS);
  }
}

function markHeroMenuActiveCards() {
  const currentPathname = normalizePathFromHref(window.location.href);
  const railSections = document.querySelectorAll(`.${HOME_HERO_CARDS_TAG_CLASS}, .${PAGE_MENU_HERO_CARDS_TAG_CLASS}`);

  for (const section of railSections) {
    const track = getHeroGroupCardsTrack(section);
    if (!track) continue;

    const cards = getHeroGroupCards(track);
    for (const card of cards) {
      const cardLinks = card.querySelectorAll(':scope > .group-block__link[href], a[href]');
      let isActiveCard = false;

      for (const link of cardLinks) {
        const linkPathname = normalizePathFromHref(link.getAttribute('href'));
        if (isHeroMenuPathActive(linkPathname, currentPathname)) {
          isActiveCard = true;
          break;
        }
      }

      card.classList.toggle('is-menu-active', isActiveCard);
      cardLinks.forEach((link) => {
        if (isActiveCard) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }
}

function scrollHeroMenuRailsToActiveCard(behavior = 'instant') {
  if (!window.matchMedia(MOBILE_BREAKPOINT).matches) return;

  const railSections = document.querySelectorAll(`.${HOME_HERO_CARDS_TAG_CLASS}, .${PAGE_MENU_HERO_CARDS_TAG_CLASS}`);

  for (const section of railSections) {
    const track = getHeroGroupCardsTrack(section);
    if (!track) continue;

    const cards = getHeroGroupCards(track);
    const activeCard = cards.find((card) => card.classList.contains('is-menu-active'));
    if (!activeCard) continue;

    const trackRect = track.getBoundingClientRect();
    const activeCardRect = activeCard.getBoundingClientRect();
    const centerDelta = activeCardRect.left + activeCardRect.width / 2 - (trackRect.left + trackRect.width / 2);
    const targetLeft = track.scrollLeft + centerDelta;
    const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
    const clampedLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));
    const currentOffset = Math.abs(track.scrollLeft - clampedLeft);

    if (currentOffset <= HERO_MENU_ACTIVE_ALIGN_TOLERANCE_PX) continue;

    if (behavior === 'smooth') {
      track.scrollTo({ left: clampedLeft, behavior: 'smooth' });
      continue;
    }

    track.scrollLeft = clampedLeft;
  }
}

function clearHeroMenuActiveAlignQueue() {
  if (!state.heroMenuAlignRafId) return;
  window.cancelAnimationFrame(state.heroMenuAlignRafId);
  state.heroMenuAlignRafId = 0;
}

function queueHeroMenuActiveAlign() {
  clearHeroMenuActiveAlignQueue();

  state.heroMenuAlignRafId = window.requestAnimationFrame(() => {
    state.heroMenuAlignRafId = window.requestAnimationFrame(() => {
      state.heroMenuAlignRafId = 0;
      scrollHeroMenuRailsToActiveCard('instant');
    });
  });
}

// Marca il carosello immagini della pagina mirtillo per applicare CSS mobile dedicato.
function markMirtilloMediaGallery() {
  const taggedSections = document.querySelectorAll(`.${MIRTILLO_MEDIA_GALLERY_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(MIRTILLO_MEDIA_GALLERY_TAG_CLASS);
  }

  const mainContent = document.querySelector('#MainContent');
  const templateName = mainContent?.getAttribute('data-template');
  if (templateName !== MIRTILLO_PAGE_TEMPLATE) return;

  const mirtilloGallerySection = getSectionByIdSuffix(MIRTILLO_MEDIA_GALLERY_SECTION_ID);
  if (mirtilloGallerySection) {
    mirtilloGallerySection.classList.add(MIRTILLO_MEDIA_GALLERY_TAG_CLASS);
  }
}

// Marca il primo carosello collezioni della pagina mirtillo (quello in alto).
function markMirtilloTopCollectionsCarousel() {
  const taggedSections = document.querySelectorAll(`.${MIRTILLO_TOP_COLLECTIONS_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(MIRTILLO_TOP_COLLECTIONS_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== MIRTILLO_PAGE_TEMPLATE) return;

  const topCollectionSection = Array.from(document.querySelectorAll('.shopify-section')).find((section) =>
    section.querySelector('[data-testid="collection-list"]'),
  );

  if (topCollectionSection) {
    topCollectionSection.classList.add(MIRTILLO_TOP_COLLECTIONS_TAG_CLASS);
  }
}

// Marca le sezioni multicolonna della pagina mirtillo per la rail mobile orizzontale.
function markMirtilloMulticolumnRails() {
  const taggedSections = document.querySelectorAll(`.${MIRTILLO_MULTICOLUMN_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(MIRTILLO_MULTICOLUMN_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== MIRTILLO_PAGE_TEMPLATE) return;

  for (const sectionId of MIRTILLO_MULTICOLUMN_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(MIRTILLO_MULTICOLUMN_TAG_CLASS);
    }
  }
}

function markMieleMulticolumnRails() {
  const taggedSections = document.querySelectorAll(`.${MIELE_MULTICOLUMN_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(MIELE_MULTICOLUMN_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== MIELE_PAGE_TEMPLATE) return;

  for (const sectionId of MIELE_MULTICOLUMN_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(MIELE_MULTICOLUMN_TAG_CLASS);
    }
  }
}

function markOlivaMulticolumnRails() {
  const taggedSections = document.querySelectorAll(`.${OLIVA_MULTICOLUMN_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(OLIVA_MULTICOLUMN_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== OLIVA_PAGE_TEMPLATE) return;

  for (const sectionId of OLIVA_MULTICOLUMN_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(OLIVA_MULTICOLUMN_TAG_CLASS);
    }
  }
}

function markAgrivoltaicoMulticolumnRails() {
  const taggedSections = document.querySelectorAll(`.${AGRIVOLTAICO_MULTICOLUMN_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(AGRIVOLTAICO_MULTICOLUMN_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== AGRIVOLTAICO_PAGE_TEMPLATE) return;

  for (const sectionId of AGRIVOLTAICO_MULTICOLUMN_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(AGRIVOLTAICO_MULTICOLUMN_TAG_CLASS);
    }
  }
}

function markAppartamentiQuadratiRails() {
  const taggedSections = document.querySelectorAll(`.${APPARTAMENTI_QUADRATI_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(APPARTAMENTI_QUADRATI_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== APPARTAMENTI_PAGE_TEMPLATE) return;

  for (const sectionId of APPARTAMENTI_QUADRATI_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(APPARTAMENTI_QUADRATI_TAG_CLASS);
    }
  }
}

function markAgrivoltaicoHomeQuadratiRails() {
  const taggedSections = document.querySelectorAll(`.${AGRIVOLTAICO_HOME_QUADRATI_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(AGRIVOLTAICO_HOME_QUADRATI_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== AGRIVOLTAICO_HOME_PAGE_TEMPLATE) return;

  for (const sectionId of AGRIVOLTAICO_HOME_QUADRATI_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(AGRIVOLTAICO_HOME_QUADRATI_TAG_CLASS);
    }
  }
}

function markLaboratorioQuadratiRails() {
  const taggedSections = document.querySelectorAll(`.${LABORATORIO_QUADRATI_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(LABORATORIO_QUADRATI_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== LABORATORIO_PAGE_TEMPLATE) return;

  for (const sectionId of LABORATORIO_QUADRATI_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(LABORATORIO_QUADRATI_TAG_CLASS);
    }
  }
}

function markProduzionePianteQuadratiRails() {
  const taggedSections = document.querySelectorAll(`.${PRODUZIONE_PIANTE_QUADRATI_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(PRODUZIONE_PIANTE_QUADRATI_TAG_CLASS);
  }

  if (getCurrentTemplateName() !== PRODUZIONE_PIANTE_PAGE_TEMPLATE) return;

  for (const sectionId of PRODUZIONE_PIANTE_QUADRATI_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(PRODUZIONE_PIANTE_QUADRATI_TAG_CLASS);
    }
  }
}

// Marca le sezioni multicolonna della pagina Shop per la rail mobile orizzontale.
function markShopMulticolumnRails() {
  const taggedSections = document.querySelectorAll(`.${SHOP_MULTICOLUMN_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(SHOP_MULTICOLUMN_TAG_CLASS);
  }

  if (!isShopTemplate()) return;

  for (const sectionId of SHOP_MULTICOLUMN_SECTION_IDS) {
    const section = getSectionByIdSuffix(sectionId);
    if (section) {
      section.classList.add(SHOP_MULTICOLUMN_TAG_CLASS);
    }
  }
}

// Marca il carosello prodotti della pagina Shop per mostrare una card alla volta su mobile.
function markShopProductListCarousel() {
  const taggedSections = document.querySelectorAll(`.${SHOP_PRODUCT_LIST_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(SHOP_PRODUCT_LIST_TAG_CLASS);
  }

  if (!isShopTemplate()) return;

  const productListSections = Array.from(document.querySelectorAll('[data-testid="product-list"]'))
    .map((node) => node.closest('.shopify-section'))
    .filter((section) => section instanceof HTMLElement);

  for (const section of productListSections) {
    section.classList.add(SHOP_PRODUCT_LIST_TAG_CLASS);
  }
}

function getShopFilterCategory(element) {
  if (!(element instanceof Element)) return '';

  const datasetCategory = element instanceof HTMLElement ? element.dataset.shopFilterCategory : '';
  if (datasetCategory && [...SHOP_FILTER_CATEGORIES, 'inactive'].includes(datasetCategory)) return datasetCategory;

  return SHOP_FILTER_CATEGORIES.find((category) => element.classList.contains(`shop-filter-${category}`)) ?? '';
}

function normalizeShopFilterText(value) {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function getShopFilterCategoriesFromText(value) {
  const text = normalizeShopFilterText(value ?? '');
  const categories = [];
  // A box can also belong to its product family (for example, Box Olio Evo).
  if (/\b(box|confezion\w*)\b/.test(text)) categories.push('box');
  if (/\bmiel\w*\b/.test(text)) categories.push('miele');
  if (/\b(olio|oliva|olive)\b/.test(text)) categories.push('olio');
  if (/\bmirtill\w*\b/.test(text)) categories.push('mirtillo');
  return categories;
}

function getShopFilterProductCategories(item) {
  // Prefer the visible product title: copied buttons can still reference another product.
  const title = item.querySelector('h1, h2, h3, h4, h5, h6')?.textContent;
  if (title?.trim()) return getShopFilterCategoriesFromText(title);
  const productTitle = item.querySelector('[data-product-title]')?.dataset.productTitle;
  if (productTitle) return getShopFilterCategoriesFromText(productTitle);
  const textOnly = item.cloneNode(true);
  textOnly.querySelectorAll('style, script, template, button').forEach((node) => node.remove());
  return getShopFilterCategoriesFromText(textOnly.textContent);
}

function shopFilterItemMatches(item, category) {
  return category === null || (item.dataset.shopFilterCategories || '').split(' ').includes(category);
}

function getShopFilterCategoryFromImage(trigger) {
  if (!(trigger instanceof HTMLElement)) return '';

  const imageText = normalizeShopFilterText(
    Array.from(trigger.querySelectorAll('img'))
      .map(
        (image) =>
          `${image.currentSrc || ''} ${image.getAttribute('src') ?? ''} ${image.getAttribute('srcset') ?? ''} ${
            image.getAttribute('alt') ?? ''
          }`,
      )
      .join(' '),
  );

  if (imageText.includes('c-01')) return 'mirtillo';
  if (imageText.includes('c-02')) return 'miele';
  if (imageText.includes('c-03')) return 'olio';
  if (imageText.includes('c-04')) return 'inactive';
  if (imageText.includes('c-05')) return 'box';

  return '';
}

function tagShopFilterTrigger(trigger, index = 0) {
  if (!(trigger instanceof HTMLElement)) return '';

  const category =
    getShopFilterCategoryFromImage(trigger) || getShopFilterCategory(trigger) || SHOP_FILTER_TRIGGER_ORDER[index] || '';
  if (!category) return '';

  for (const previous of [...SHOP_FILTER_CATEGORIES, 'nettare', 'all', 'inactive']) trigger.classList.remove(`shop-filter-${previous}`);
  trigger.classList.add(SHOP_FILTER_TRIGGER_CLASS, `shop-filter-${category}`);
  trigger.dataset.shopFilterCategory = category;
  return category;
}

function getShopFilterFallbackTriggers() {
  const imageGroups = [];
  const iconImages = document.querySelectorAll('img[src*="Tasti-icone"], img[src*="shop-menu"], img[alt*="Tasti"]');

  for (const image of iconImages) {
    const group = image.closest('.group-block');
    if (group instanceof HTMLElement && !imageGroups.includes(group)) {
      imageGroups.push(group);
    }
  }

  if (imageGroups.length >= SHOP_FILTER_TRIGGER_ORDER.length) {
    return imageGroups.slice(0, SHOP_FILTER_TRIGGER_ORDER.length);
  }

  const heroSections = Array.from(document.querySelectorAll('.shopify-section.hero-wrapper'));
  for (const section of heroSections) {
    const track = getHeroGroupCardsTrack(section);
    const cards = getHeroGroupCards(track).filter(
      (card) => card.querySelector('.image-block') && !card.querySelector('.text-block'),
    );

    if (cards.length >= SHOP_FILTER_TRIGGER_ORDER.length) {
      return cards.slice(0, SHOP_FILTER_TRIGGER_ORDER.length);
    }
  }

  return [];
}

function getShopFilterTriggers() {
  const explicitTriggers = Array.from(document.querySelectorAll(`.${SHOP_FILTER_TRIGGER_CLASS}`)).filter(
    (trigger) => trigger instanceof HTMLElement,
  );
  const fallbackTriggers = getShopFilterFallbackTriggers();
  const triggers = Array.from(new Set([...explicitTriggers, ...fallbackTriggers]));

  triggers.forEach((trigger, index) => tagShopFilterTrigger(trigger, index));
  return triggers;
}

function getShopFilterItems() {
  const main = document.querySelector('#MainContent');
  if (!main) return [];
  const candidates = Array.from(main.querySelectorAll(
    '.section-content-wrapper > .multicolumn-card-hover, .shop-filter-item, .resource-list__item, product-card',
  ));
  // A resource-list item may contain a product-card: filter its outer wrapper only.
  const items = candidates.filter((item) => !candidates.some((parent) => parent !== item && parent.contains(item)));
  for (const item of items) {
    const categories = getShopFilterProductCategories(item);
    for (const previous of [...SHOP_FILTER_CATEGORIES, 'nettare', 'all', 'inactive']) item.classList.remove(`shop-filter-${previous}`);
    item.classList.add(SHOP_FILTER_ITEM_CLASS, ...categories.map((category) => `shop-filter-${category}`));
    item.dataset.shopFilterCategories = categories.join(' ');
    item.dataset.shopFilterCategory = categories[0] || '';
  }
  return items;
}

function disableShopFilterTriggerLinks(trigger) {
  if (!(trigger instanceof HTMLElement)) return;

  if (trigger.getAttribute('role') !== 'button') {
    trigger.setAttribute('role', 'button');
  }

  if (trigger.getAttribute('tabindex') !== '0') {
    trigger.setAttribute('tabindex', '0');
  }

  const category = getShopFilterCategory(trigger);
  if (category && trigger.dataset.shopFilterCategory !== category) {
    trigger.dataset.shopFilterCategory = category;
  }
  const inactive = category === 'inactive';
  trigger.setAttribute('aria-disabled', String(inactive));
  trigger.setAttribute('tabindex', inactive ? '-1' : '0');
  for (const link of trigger.querySelectorAll('a')) {
    if (inactive) {
      if (link.hasAttribute('href')) link.dataset.shopFilterOriginalHref = link.getAttribute('href');
      link.removeAttribute('href');
      link.setAttribute('tabindex', '-1');
    }
  }
  trigger.setAttribute('aria-label', SHOP_FILTER_LABELS[category] || 'Filtra prodotti');
  trigger.setAttribute('title', SHOP_FILTER_LABELS[category] || 'Filtra prodotti');
}

function bindShopFilterTrigger(trigger) {
  if (!(trigger instanceof HTMLElement)) return;

  disableShopFilterTriggerLinks(trigger);

  if (trigger.getAttribute(SHOP_FILTER_BOUND_ATTR) === 'true') return;

  trigger.setAttribute(SHOP_FILTER_BOUND_ATTR, 'true');
  trigger.addEventListener('click', handleShopProductFilterClick);
  trigger.addEventListener('keydown', handleShopProductFilterKeydown);
}

function getShopFilterGsap() {
  return typeof window !== 'undefined' && window.gsap && typeof window.gsap.timeline === 'function'
    ? window.gsap
    : null;
}

function shouldAnimateShopFilter() {
  return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function stopShopFilterTimeline() {
  if (state.shopFilterTimeline && typeof state.shopFilterTimeline.kill === 'function') {
    state.shopFilterTimeline.kill();
  }

  state.shopFilterTimeline = null;

  for (const item of getShopFilterItems()) {
    item.classList.remove(SHOP_FILTER_ANIMATING_CLASS);
    item.style.removeProperty('opacity');
    item.style.removeProperty('visibility');
    item.style.removeProperty('transform');
    item.style.removeProperty('filter');
  }
}

function getShopFilterTracks(items) {
  const tracks = new Map();
  for (const item of items) {
    const track = item.parentElement;
    if (!track) continue;
    if (!tracks.has(track)) tracks.set(track, []);
    tracks.get(track).push(item);
  }
  return tracks;
}

// Keep the original nodes (and their forms) while presenting results from all rows together.
function moveShopFilterCard(parent, item, before = null) {
  if (typeof parent.moveBefore === 'function' && item.isConnected && parent.isConnected) {
    parent.moveBefore(item, before);
  } else {
    parent.insertBefore(item, before);
  }
}

function restoreShopFilterGrid() {
  const grid = state.shopFilterGrid;
  if (!grid) return;

  shopFilterObserver?.disconnect();
  try {
    for (const [item, origin] of grid.origins) {
      if (origin.placeholder.isConnected) {
        moveShopFilterCard(origin.track, item, origin.placeholder);
      } else {
        // A section replaced in the editor must not leave an old copy in the results.
        item.remove();
      }
      origin.placeholder.remove();
    }
    grid.track.classList.remove('shop-filter-grid');
    for (const section of grid.sections) section.classList.remove('is-shop-filter-source-empty');
    state.shopFilterGrid = null;
  } finally {
    observeShopProductFilterDom();
  }
}

function syncShopFilterGrid(items, isFiltering) {
  if (!isFiltering) {
    restoreShopFilterGrid();
    return;
  }

  const cards = items.filter((item) => item.matches('.section-content-wrapper > .multicolumn-card-hover'));
  if (!cards.length) return;

  const grid = state.shopFilterGrid ?? {
    track: cards[0].parentElement,
    origins: new Map(),
    sections: new Set(),
  };
  state.shopFilterGrid = grid;
  // Disconnect only while moving nodes: the observer must still see genuine editor updates.
  shopFilterObserver?.disconnect();
  try {
    for (const item of cards) {
      if (!grid.origins.has(item)) {
        const track = item.parentElement;
        const placeholder = document.createComment('shop-filter-original-position');
        track.insertBefore(placeholder, item);
        grid.origins.set(item, { track, placeholder });
        grid.sections.add(item.closest('.shopify-section'));
      }
      if (item.parentElement !== grid.track) moveShopFilterCard(grid.track, item);
    }
    grid.track.classList.add('shop-filter-grid');
    for (const section of grid.sections) {
      section?.classList.toggle('is-shop-filter-source-empty', !section.contains(grid.track));
    }
  } finally {
    observeShopProductFilterDom();
  }
}

function getShopFilterCardWidth(track, items) {
  if (track.classList.contains('shop-filter-grid')) return 'var(--shop-filter-card-width)';

  const styles = window.getComputedStyle(track);
  const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
  const columns = window.matchMedia(MOBILE_BREAKPOINT).matches ? 2 : Math.max(items.length, 1);
  // Relative widths stay correct when resizing inside the same breakpoint.
  return `calc((100% - ${gap * (columns - 1)}px) / ${columns})`;
}

function updateShopFilterSections(items, activeCategory) {
  const sections = new Set(items.map((item) => item.closest('.shopify-section')).filter(Boolean));
  for (const section of sections) {
    const sectionItems = items.filter((item) => section.contains(item));
    const empty = activeCategory !== null && !sectionItems.some((item) => shopFilterItemMatches(item, activeCategory));
    section.classList.toggle('is-shop-filter-empty', empty);
  }
}

function getShopFilterItemRects(items) {
  const rects = new Map();

  for (const item of items) {
    if (!(item instanceof HTMLElement)) continue;

    const rect = item.getBoundingClientRect();
    if (rect.width > 0 && rect.height > 0) {
      rects.set(item, rect);
    }
  }

  return rects;
}

function isShopFilterItemVisible(item) {
  if (!(item instanceof HTMLElement)) return false;
  if (item.hidden) return false;

  return window.getComputedStyle(item).display !== 'none';
}

function storeShopFilterStyleValue(element, key, property) {
  if (!(element instanceof HTMLElement)) return;
  if (element.dataset[key] != null) return;

  const value = element.style.getPropertyValue(property);
  element.dataset[key] = value || '__NONE__';
}

function restoreShopFilterStyleValue(element, key, property) {
  if (!(element instanceof HTMLElement)) return;

  const value = element.dataset[key];
  if (value == null) return;

  if (value === '__NONE__') {
    element.style.removeProperty(property);
  } else {
    element.style.setProperty(property, value);
  }

  delete element.dataset[key];
}

function setShopFilterTrackActive(track, isActive) {
  if (!(track instanceof HTMLElement)) return;

  track.classList.toggle(SHOP_FILTER_TRACK_ACTIVE_CLASS, isActive);

  if (isActive) {
    storeShopFilterStyleValue(track, 'shopFilterOriginalJustifyContent', 'justify-content');
    storeShopFilterStyleValue(track, 'shopFilterOriginalAlignItems', 'align-items');
    track.style.setProperty('justify-content', track.classList.contains('shop-filter-grid') ? 'flex-start' : 'center', 'important');
    track.style.setProperty('align-items', 'stretch', 'important');
    return;
  }

  restoreShopFilterStyleValue(track, 'shopFilterOriginalJustifyContent', 'justify-content');
  restoreShopFilterStyleValue(track, 'shopFilterOriginalAlignItems', 'align-items');
}

function setShopFilterItemSize(item, isFiltering, cardWidth) {
  if (!(item instanceof HTMLElement)) return;

  if (isFiltering) {
    storeShopFilterStyleValue(item, 'shopFilterOriginalFlex', 'flex');
    storeShopFilterStyleValue(item, 'shopFilterOriginalWidth', 'width');
    storeShopFilterStyleValue(item, 'shopFilterOriginalMinWidth', 'min-width');
    storeShopFilterStyleValue(item, 'shopFilterOriginalMaxWidth', 'max-width');
    storeShopFilterStyleValue(item, 'shopFilterOriginalHeight', 'height');
    storeShopFilterStyleValue(item, 'shopFilterOriginalMinHeight', 'min-height');

    const width = cardWidth;
    item.style.setProperty('flex', `0 0 ${width}`, 'important');
    item.style.setProperty('width', width, 'important');
    item.style.setProperty('min-width', width, 'important');
    item.style.setProperty('max-width', width, 'important');
    item.style.setProperty('height', 'auto', 'important');
    item.style.setProperty('min-height', '0', 'important');
    return;
  }

  restoreShopFilterStyleValue(item, 'shopFilterOriginalFlex', 'flex');
  restoreShopFilterStyleValue(item, 'shopFilterOriginalWidth', 'width');
  restoreShopFilterStyleValue(item, 'shopFilterOriginalMinWidth', 'min-width');
  restoreShopFilterStyleValue(item, 'shopFilterOriginalMaxWidth', 'max-width');
  restoreShopFilterStyleValue(item, 'shopFilterOriginalHeight', 'height');
  restoreShopFilterStyleValue(item, 'shopFilterOriginalMinHeight', 'min-height');
}

function setShopFilterItemHidden(item, shouldHide, isFiltering, cardWidth) {
  if (!(item instanceof HTMLElement)) return;

  item.classList.toggle(SHOP_FILTER_HIDDEN_CLASS, shouldHide);
  item.toggleAttribute('hidden', shouldHide);
  item.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
  setShopFilterItemSize(item, isFiltering, cardWidth);

  if (shouldHide) {
    item.style.setProperty('display', 'none', 'important');
  } else {
    item.style.removeProperty('display');
    item.removeAttribute('aria-hidden');
  }
}

function prepareShopFilterItemVisible(item, isFiltering, cardWidth) {
  if (!(item instanceof HTMLElement)) return;

  item.classList.remove(SHOP_FILTER_HIDDEN_CLASS);
  item.removeAttribute('hidden');
  item.removeAttribute('aria-hidden');
  item.style.removeProperty('display');
  setShopFilterItemSize(item, isFiltering, cardWidth);
}

function applyShopFilterItemsInstant(items, activeCategory, isFiltering, cardWidths) {
  for (const item of items) {
    const isMatch = activeCategory !== null && shopFilterItemMatches(item, activeCategory);
    const shouldHide = activeCategory !== null && !isMatch;

    item.classList.toggle(SHOP_FILTER_MATCH_CLASS, isMatch);
    item.classList.remove(SHOP_FILTER_ANIMATING_CLASS);
    setShopFilterItemHidden(item, shouldHide, isFiltering, cardWidths.get(item));
  }
}

function animateShopFilterTriggers(triggers, activeCategory) {
  const gsap = getShopFilterGsap();
  if (!gsap || !shouldAnimateShopFilter()) return;

  gsap.killTweensOf(triggers);
  gsap.set(triggers, { clearProps: 'filter' });
  gsap.to(triggers, {
    opacity: (_index, trigger) => (activeCategory !== null && getShopFilterCategory(trigger) !== activeCategory ? 0.28 : 1),
    scale: (_index, trigger) =>
      activeCategory === null ? 1 : getShopFilterCategory(trigger) === activeCategory ? 1.03 : 0.98,
    y: (_index, trigger) => (activeCategory !== null && getShopFilterCategory(trigger) === activeCategory ? -2 : 0),
    duration: 0.24,
    ease: 'power2.out',
    overwrite: 'auto',
  });
}

function animateShopFilterItems(items, activeCategory, isFiltering, cardWidths) {
  const gsap = getShopFilterGsap();
  stopShopFilterTimeline();
  gsap?.killTweensOf(items);

  if (!gsap || !shouldAnimateShopFilter()) {
    applyShopFilterItemsInstant(items, activeCategory, isFiltering, cardWidths);
    return;
  }

  const visibleItems = [];

  for (const item of items) {
    const isMatch = activeCategory !== null && shopFilterItemMatches(item, activeCategory);
    const shouldHide = activeCategory !== null && !isMatch;

    item.classList.toggle(SHOP_FILTER_MATCH_CLASS, isMatch);

    if (shouldHide) {
      item.style.removeProperty('transform');
      gsap.set(item, { autoAlpha: 0 });
      setShopFilterItemHidden(item, true, isFiltering, cardWidths.get(item));
      continue;
    }

    prepareShopFilterItemVisible(item, isFiltering, cardWidths.get(item));
    item.style.removeProperty('transform');
    gsap.set(item, { autoAlpha: 0.82 });
    visibleItems.push(item);
  }

  const timeline = gsap.timeline({
    defaults: { ease: 'power1.out' },
    onComplete: () => {
      for (const item of items) {
        item.classList.remove(SHOP_FILTER_ANIMATING_CLASS);
        item.style.removeProperty('transform');
      }

      state.shopFilterTimeline = null;
    },
  });

  if (visibleItems.length > 0) {
    timeline.to(visibleItems, {
      autoAlpha: 1,
      duration: 0.22,
      stagger: activeCategory === null ? { each: 0.025, from: 'start' } : 0,
      clearProps: 'opacity,visibility',
      overwrite: 'auto',
    }, 0);
  }

  state.shopFilterTimeline = timeline;
}

function applyShopProductFilter(category = state.shopFilterCategory, options = {}) {
  if (!isShopTemplate()) return;

  const activeCategory = SHOP_FILTER_CATEGORIES.includes(category) ? category : null;
  const triggers = getShopFilterTriggers();
  // Recover before collecting cards if Shopify replaced a source section.
  if (state.shopFilterGrid && (!state.shopFilterGrid.track.isConnected ||
      [...state.shopFilterGrid.origins.values()].some((origin) => !origin.placeholder.isConnected))) {
    restoreShopFilterGrid();
  }
  const items = getShopFilterItems();
  const isFiltering = activeCategory !== null;
  syncShopFilterGrid(items, isFiltering);
  const cardWidths = new Map();
  updateShopFilterSections(items, activeCategory);
  for (const [track, trackItems] of getShopFilterTracks(items)) {
    setShopFilterTrackActive(track, isFiltering);
    const width = getShopFilterCardWidth(track, trackItems);
    for (const item of trackItems) cardWidths.set(item, width);
  }

  // Filtering owns these cards' reveal; pending scroll reveals must not hide results.
  if (isFiltering || state.shopFilterCategory !== null) {
    for (const item of items) {
      item.dataset.ziliusReveal = 'done';
      item.classList.remove('zilius-reveal-item');
    }
  }

  state.shopFilterCategory = activeCategory;

  for (const trigger of triggers) {
    bindShopFilterTrigger(trigger);

    const isActive = activeCategory !== null && getShopFilterCategory(trigger) === activeCategory;
    const isDimmed = activeCategory !== null && !isActive;
    trigger.classList.toggle(SHOP_FILTER_ACTIVE_CLASS, isActive);
    trigger.classList.toggle(SHOP_FILTER_DIMMED_CLASS, isDimmed);
    trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');

    const links = trigger.querySelectorAll('a[role="button"]');
    for (const link of links) {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  if (options.animate === false) {
    stopShopFilterTimeline();
    const gsap = getShopFilterGsap();

    if (gsap) {
      gsap.killTweensOf([...triggers, ...items]);
      gsap.set(triggers, { clearProps: 'opacity,transform,filter' });
      gsap.set(items, { clearProps: 'opacity,visibility,transform,filter' });
    }

    applyShopFilterItemsInstant(items, activeCategory, isFiltering, cardWidths);
    return;
  }

  animateShopFilterTriggers(triggers, activeCategory);
  animateShopFilterItems(items, activeCategory, isFiltering, cardWidths);
}

function setupShopProductFilter() {
  if (!isShopTemplate()) {
    state.shopFilterCategory = null;
    return;
  }

  const triggers = getShopFilterTriggers();
  const items = getShopFilterItems();

  for (const trigger of triggers) {
    bindShopFilterTrigger(trigger);
  }

  if (triggers.length === 0 && items.length === 0) {
    state.shopFilterCategory = null;
    return;
  }

  applyShopProductFilter(state.shopFilterCategory, { animate: false });
}

function queueShopProductFilterSetup() {
  if (state.shopFilterSetupRafId) return;

  state.shopFilterSetupRafId = window.requestAnimationFrame(() => {
    state.shopFilterSetupRafId = 0;
    setupShopProductFilter();
  });
}

function handleShopProductFilterClick(event) {
  if (!isShopTemplate()) return;

  if (!(event.target instanceof Element)) return;
  if (event.target.closest(`.${SHOP_FILTER_ITEM_CLASS} a[href], .${SHOP_FILTER_ITEM_CLASS} .group-block__link[href]`)) {
    return;
  }

  const trigger =
    event.currentTarget instanceof HTMLElement && event.currentTarget.classList.contains(SHOP_FILTER_TRIGGER_CLASS)
      ? event.currentTarget
      : event.target.closest(`.${SHOP_FILTER_TRIGGER_CLASS}`) ??
        getShopFilterTriggers().find((filterTrigger) => filterTrigger.contains(event.target));
  if (!(trigger instanceof HTMLElement)) return;

  const category = getShopFilterCategory(trigger);
  if (!category) return;

  event.preventDefault();
  event.stopPropagation();

  if (category === 'inactive') return;

  const nextCategory = state.shopFilterCategory === category ? null : category;
  applyShopProductFilter(nextCategory);

  if (window.matchMedia(MOBILE_BREAKPOINT).matches) {
    setupAutoColumnRails();
  }
}

function handleShopProductFilterKeydown(event) {
  if (!isShopTemplate()) return;

  if (!(event instanceof KeyboardEvent)) return;
  if (event.key !== 'Enter' && event.key !== ' ') return;

  event.preventDefault();
  if (event.repeat) return;
  handleShopProductFilterClick(event);
}

// Trova una sezione tramite l'id finale generato da Shopify.
function getSectionByIdSuffix(sectionId) {
  return document.querySelector(`[id$="__${sectionId}"]`);
}

// Restituisce la prima coppia valida di sezioni prodotti da unire.
function getProductsSections() {
  for (const [firstId, secondId] of HOME_PRODUCTS_SECTION_PAIRS) {
    const firstSection = getSectionByIdSuffix(firstId);
    const secondSection = getSectionByIdSuffix(secondId);

    if (firstSection && secondSection) {
      return { firstSection, secondSection };
    }
  }

  return null;
}

// Su mobile: sposta le card della seconda sezione dentro la prima, creando una rail unica.
function applyMobileProductsRail() {
  if (state.applied) return;

  const sections = getProductsSections();
  if (!sections) return;

  const firstTrack = sections.firstSection.querySelector('[data-testid="section-content"]');
  const secondTrack = sections.secondSection.querySelector('[data-testid="section-content"]');

  if (!firstTrack || !secondTrack) return;

  const cardsToMove = Array.from(secondTrack.children).filter(
    (child) => child instanceof HTMLElement && child.classList.contains('group-block'),
  );

  if (cardsToMove.length === 0) return;

  state.firstSection = sections.firstSection;
  state.secondSection = sections.secondSection;
  state.firstTrack = firstTrack;
  state.firstHadMobileColumn = firstTrack.classList.contains('mobile-column');
  state.movedCards = cardsToMove;
  state.placeholders = [];

  if (state.firstHadMobileColumn) {
    firstTrack.classList.remove('mobile-column');
  }

  sections.firstSection.classList.add('mobile-home-products-rail');
  firstTrack.classList.add('mobile-home-products-track');
  sections.secondSection.classList.add('mobile-home-products-source-hidden');

  for (const card of cardsToMove) {
    const marker = document.createComment('mobile-home-products-placeholder');
    card.before(marker);
    state.placeholders.push(marker);
    firstTrack.appendChild(card);
  }

  state.applied = true;
}

function getHomeProductsSlides(track) {
  return Array.from(track.children).filter(
    (child) => child instanceof HTMLElement && child.classList.contains('group-block'),
  );
}

function getSectionContentTrack(section) {
  if (!(section instanceof HTMLElement)) return null;

  const sectionElement = Array.from(section.children).find(
    (child) => child instanceof HTMLElement && child.classList.contains('section'),
  );

  if (!(sectionElement instanceof HTMLElement)) return null;

  const track = sectionElement.querySelector('.custom-section-content > [data-testid="section-content"]');
  return track instanceof HTMLElement ? track : null;
}

function getSectionGroupSlides(track) {
  if (!(track instanceof HTMLElement)) return [];

  return Array.from(track.children).filter(
    (child) => child instanceof HTMLElement && child.classList.contains('group-block'),
  );
}

function sectionMatchesIdSuffixes(section, sectionIds) {
  if (!(section instanceof HTMLElement)) return false;
  return sectionIds.some((sectionId) => section.id.endsWith(`__${sectionId}`));
}

function slideHasVisualMedia(slide) {
  if (!(slide instanceof HTMLElement)) return false;

  return Boolean(
    slide.querySelector(
      '.image-block, .image-block__image, .group-block__media-wrapper img, .group-block__media-wrapper svg, .background-image-container',
    ),
  );
}

function isAutoColumnRailCandidate(section) {
  if (!(section instanceof HTMLElement)) return false;
  if (section.classList.contains('mobile-home-products-source-hidden')) return false;
  if (sectionMatchesIdSuffixes(section, HOME_PRODUCTS_SECTION_IDS)) return false;
  if (sectionMatchesIdSuffixes(section, [SHOP_FILTER_PRODUCTS_SECTION_ID])) return false;
  // Product multicolumn copies share the mobile grid, including new editor sections.
  if (isShopTemplate() && section.querySelector('[data-testid="section-content"] > .multicolumn-card-hover')) return false;
  if (sectionMatchesIdSuffixes(section, [GIN_MIRTILLO_DETAILS_SECTION_ID])) return false;

  const track = getSectionContentTrack(section);
  if (!track || !track.classList.contains('layout-panel-flex--row')) return false;

  const slides = getSectionGroupSlides(track);
  const trackChildren = Array.from(track.children).filter((child) => child instanceof HTMLElement);

  if (slides.length < 2 || slides.length !== trackChildren.length) return false;
  return slides.every((slide) => slideHasVisualMedia(slide));
}

function markAutoColumnRails() {
  const taggedSections = document.querySelectorAll(`.${AUTO_COLUMN_RAIL_TAG_CLASS}`);
  for (const section of taggedSections) {
    section.classList.remove(AUTO_COLUMN_RAIL_TAG_CLASS);
  }

  const sections = document.querySelectorAll('.shopify-section');
  for (const section of sections) {
    if (isAutoColumnRailCandidate(section)) {
      section.classList.add(AUTO_COLUMN_RAIL_TAG_CLASS);
    }
  }
}

function getCenteredSlideIndex(track, slides) {
  if (!track || slides.length === 0) return 0;

  const trackRect = track.getBoundingClientRect();
  const trackCenter = trackRect.left + trackRect.width / 2;
  let bestIndex = 0;
  let smallestDistance = Number.POSITIVE_INFINITY;

  slides.forEach((slide, index) => {
    const slideRect = slide.getBoundingClientRect();
    const slideCenter = slideRect.left + slideRect.width / 2;
    const distance = Math.abs(slideCenter - trackCenter);

    if (distance < smallestDistance) {
      smallestDistance = distance;
      bestIndex = index;
    }
  });

  return bestIndex;
}

function setHomeProductsActiveDot(index) {
  state.carousel.activeIndex = index;

  state.carousel.dots.forEach((dot, dotIndex) => {
    const isActive = dotIndex === index;
    dot.classList.toggle('is-active', isActive);
    dot.setAttribute('aria-current', isActive ? 'true' : 'false');
  });
}

function scrollHomeProductsToIndex(index, behavior = 'smooth') {
  const { track, slides } = state.carousel;
  const targetSlide = slides[index];

  if (!track || !targetSlide) return;

  const trackRect = track.getBoundingClientRect();
  const targetSlideRect = targetSlide.getBoundingClientRect();
  const centerDelta = targetSlideRect.left + targetSlideRect.width / 2 - (trackRect.left + trackRect.width / 2);
  const targetLeft = track.scrollLeft + centerDelta;
  const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
  const clampedLeft = Math.min(Math.max(0, targetLeft), maxScrollLeft);
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollBehavior = prefersReducedMotion ? 'auto' : behavior;

  if (Math.abs(track.scrollLeft - clampedLeft) > 1) {
    track.scrollTo({ left: clampedLeft, behavior: scrollBehavior });
  }
  setHomeProductsActiveDot(index);
}

function updateHomeProductsActiveFromScroll() {
  if (state.carousel.scrollRafId) return;

  state.carousel.scrollRafId = window.requestAnimationFrame(() => {
    state.carousel.scrollRafId = 0;

    const { track, slides } = state.carousel;
    if (!track || slides.length === 0) return;

    const activeIndex = getCenteredSlideIndex(track, slides);
    if (activeIndex !== state.carousel.activeIndex) {
      setHomeProductsActiveDot(activeIndex);
    }
  });
}

function clearHomeProductsAutoplayInterval() {
  if (!state.carousel.autoplayIntervalId) return;
  window.clearInterval(state.carousel.autoplayIntervalId);
  state.carousel.autoplayIntervalId = 0;
}

function clearHomeProductsAutoplayResumeTimeout() {
  if (!state.carousel.autoplayResumeTimeoutId) return;
  window.clearTimeout(state.carousel.autoplayResumeTimeoutId);
  state.carousel.autoplayResumeTimeoutId = 0;
}

function startHomeProductsAutoplay() {
  clearHomeProductsAutoplayInterval();

  const isMobile = window.matchMedia(MOBILE_BREAKPOINT).matches;
  const { track, slides } = state.carousel;

  if (!isMobile || shouldReduceAutomaticMotion() || document.hidden || !track || slides.length < 2) return;

  state.carousel.autoplayIntervalId = window.setInterval(() => {
    if (!isElementInViewport(track)) return;
    const nextIndex = (state.carousel.activeIndex + 1) % slides.length;
    scrollHomeProductsToIndex(nextIndex);
  }, HOME_PRODUCTS_AUTOPLAY_INTERVAL_MS);
}

function pauseHomeProductsAutoplay() {
  clearHomeProductsAutoplayInterval();
  clearHomeProductsAutoplayResumeTimeout();

  state.carousel.autoplayResumeTimeoutId = window.setTimeout(() => {
    startHomeProductsAutoplay();
  }, HOME_PRODUCTS_AUTOPLAY_RESUME_DELAY_MS);
}

function destroyHomeProductsCarousel() {
  const { track, controls, onScroll, onInteraction, onVisibilityChange, scrollRafId } = state.carousel;

  if (track && onScroll) {
    track.removeEventListener('scroll', onScroll);
  }

  if (track && onInteraction) {
    track.removeEventListener('pointerdown', onInteraction);
    track.removeEventListener('touchstart', onInteraction);
    track.removeEventListener('wheel', onInteraction);
  }

  if (onVisibilityChange) {
    document.removeEventListener('visibilitychange', onVisibilityChange);
  }

  if (controls) {
    controls.remove();
  }

  if (scrollRafId) {
    window.cancelAnimationFrame(scrollRafId);
  }

  clearHomeProductsAutoplayInterval();
  clearHomeProductsAutoplayResumeTimeout();

  state.carousel.track = null;
  state.carousel.slides = [];
  state.carousel.controls = null;
  state.carousel.dots = [];
  state.carousel.activeIndex = 0;
  state.carousel.scrollRafId = 0;
  state.carousel.onScroll = null;
  state.carousel.onInteraction = null;
  state.carousel.onVisibilityChange = null;
}

function setupHomeProductsCarousel() {
  destroyHomeProductsCarousel();

  if (!state.applied || !state.firstTrack || !state.firstSection) return;

  const track = state.firstTrack;
  const slides = getHomeProductsSlides(track);
  const controlsHost = track.parentElement;

  if (slides.length < 2 || !controlsHost) return;

  const controls = document.createElement('div');
  controls.className = 'mobile-home-products-controls';
  controls.setAttribute('aria-label', 'Indicatori blocchi prodotti');

  const dots = slides.map((_, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'mobile-home-products-dot';
    dot.setAttribute('aria-label', `Vai al blocco prodotto ${index + 1}`);
    dot.setAttribute('aria-current', 'false');

    dot.addEventListener('click', () => {
      pauseHomeProductsAutoplay();
      scrollHomeProductsToIndex(index);
    });

    controls.appendChild(dot);
    return dot;
  });

  controlsHost.appendChild(controls);

  state.carousel.track = track;
  state.carousel.slides = slides;
  state.carousel.controls = controls;
  state.carousel.dots = dots;
  state.carousel.activeIndex = getCenteredSlideIndex(track, slides);

  const onScroll = () => {
    updateHomeProductsActiveFromScroll();
  };

  const onInteraction = () => {
    pauseHomeProductsAutoplay();
  };

  const onVisibilityChange = () => {
    if (document.hidden) {
      clearHomeProductsAutoplayInterval();
      clearHomeProductsAutoplayResumeTimeout();
      return;
    }

    startHomeProductsAutoplay();
  };

  state.carousel.onScroll = onScroll;
  state.carousel.onInteraction = onInteraction;
  state.carousel.onVisibilityChange = onVisibilityChange;

  track.addEventListener('scroll', onScroll, { passive: true });
  track.addEventListener('pointerdown', onInteraction, { passive: true });
  track.addEventListener('touchstart', onInteraction, { passive: true });
  track.addEventListener('wheel', onInteraction, { passive: true });
  document.addEventListener('visibilitychange', onVisibilityChange);

  // Centra una sola volta, dopo che il layout mobile ha completato due frame.
  setHomeProductsActiveDot(0);
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      scrollHomeProductsToIndex(0, 'auto');
      startHomeProductsAutoplay();
    });
  });
}

function setAutoColumnRailActiveDot(controller, index) {
  controller.activeIndex = index;

  controller.dots.forEach((dot, dotIndex) => {
    const isActive = dotIndex === index;
    dot.classList.toggle('is-active', isActive);
    dot.setAttribute('aria-current', isActive ? 'true' : 'false');
  });
}

function scrollAutoColumnRailToIndex(controller, index, behavior = 'smooth') {
  const targetSlide = controller.slides[index];

  if (!controller.track || !targetSlide) return;

  const trackRect = controller.track.getBoundingClientRect();
  const targetSlideRect = targetSlide.getBoundingClientRect();
  const centerDelta = targetSlideRect.left + targetSlideRect.width / 2 - (trackRect.left + trackRect.width / 2);
  const targetLeft = controller.track.scrollLeft + centerDelta;
  const maxScrollLeft = Math.max(0, controller.track.scrollWidth - controller.track.clientWidth);
  const clampedLeft = Math.min(Math.max(0, targetLeft), maxScrollLeft);
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollBehavior = prefersReducedMotion ? 'auto' : behavior;

  if (Math.abs(controller.track.scrollLeft - clampedLeft) > 1) {
    controller.track.scrollTo({ left: clampedLeft, behavior: scrollBehavior });
  }
  setAutoColumnRailActiveDot(controller, index);
}

function updateAutoColumnRailActiveFromScroll(controller) {
  if (controller.scrollRafId) return;

  controller.scrollRafId = window.requestAnimationFrame(() => {
    controller.scrollRafId = 0;

    if (!controller.track || controller.slides.length === 0) return;

    const activeIndex = getCenteredSlideIndex(controller.track, controller.slides);
    if (activeIndex !== controller.activeIndex) {
      setAutoColumnRailActiveDot(controller, activeIndex);
    }
  });
}

function clearAutoColumnRailAutoplayInterval(controller) {
  if (!controller.autoplayIntervalId) return;
  window.clearInterval(controller.autoplayIntervalId);
  controller.autoplayIntervalId = 0;
}

function clearAutoColumnRailAutoplayResumeTimeout(controller) {
  if (!controller.autoplayResumeTimeoutId) return;
  window.clearTimeout(controller.autoplayResumeTimeoutId);
  controller.autoplayResumeTimeoutId = 0;
}

function startAutoColumnRailAutoplay(controller) {
  clearAutoColumnRailAutoplayInterval(controller);

  const isMobile = window.matchMedia(MOBILE_BREAKPOINT).matches;

  if (
    !isMobile ||
    shouldReduceAutomaticMotion() ||
    document.hidden ||
    !controller.isVisible ||
    !controller.track ||
    controller.slides.length < 2
  ) {
    return;
  }

  controller.autoplayIntervalId = window.setInterval(() => {
    const nextIndex = (controller.activeIndex + 1) % controller.slides.length;
    scrollAutoColumnRailToIndex(controller, nextIndex);
  }, AUTO_COLUMN_AUTOPLAY_INTERVAL_MS);
}

function pauseAutoColumnRailAutoplay(controller) {
  clearAutoColumnRailAutoplayInterval(controller);
  clearAutoColumnRailAutoplayResumeTimeout(controller);

  controller.autoplayResumeTimeoutId = window.setTimeout(() => {
    startAutoColumnRailAutoplay(controller);
  }, AUTO_COLUMN_AUTOPLAY_RESUME_DELAY_MS);
}

function handleAutoColumnRailIntersection(entries) {
  for (const entry of entries) {
    const controller = autoColumnRailControllers.get(entry.target);
    if (!controller) continue;

    controller.isVisible =
      entry.isIntersecting && entry.intersectionRatio >= AUTO_COLUMN_VISIBILITY_THRESHOLD;

    if (controller.isVisible) {
      startAutoColumnRailAutoplay(controller);
      continue;
    }

    clearAutoColumnRailAutoplayInterval(controller);
    clearAutoColumnRailAutoplayResumeTimeout(controller);
  }
}

function destroyAutoColumnRail(section) {
  const controller = autoColumnRailControllers.get(section);
  if (!controller) return;

  if (controller.track && controller.onScroll) {
    controller.track.removeEventListener('scroll', controller.onScroll);
  }

  if (controller.track && controller.onInteraction) {
    controller.track.removeEventListener('pointerdown', controller.onInteraction);
    controller.track.removeEventListener('touchstart', controller.onInteraction);
    controller.track.removeEventListener('wheel', controller.onInteraction);
  }

  if (controller.onVisibilityChange) {
    document.removeEventListener('visibilitychange', controller.onVisibilityChange);
  }

  if (controller.controls) {
    controller.controls.remove();
  }

  if (controller.scrollRafId) {
    window.cancelAnimationFrame(controller.scrollRafId);
  }

  clearAutoColumnRailAutoplayInterval(controller);
  clearAutoColumnRailAutoplayResumeTimeout(controller);
  controller.track?.classList.remove(AUTO_COLUMN_TRACK_CLASS);
  autoColumnRailObserver?.unobserve(section);
  autoColumnRailControllers.delete(section);
}

function destroyAutoColumnRails() {
  for (const section of Array.from(autoColumnRailControllers.keys())) {
    destroyAutoColumnRail(section);
  }
}

function setupAutoColumnRail(section) {
  destroyAutoColumnRail(section);

  const track = getSectionContentTrack(section);
  const slides = getSectionGroupSlides(track).filter((slide) => !slide.classList.contains(SHOP_FILTER_HIDDEN_CLASS));
  const controlsHost = track?.parentElement;

  if (!track || !controlsHost) return;

  track.classList.add(AUTO_COLUMN_TRACK_CLASS);

  if (slides.length < 2) return;

  const controls = document.createElement('div');
  controls.className = AUTO_COLUMN_CONTROLS_CLASS;
  controls.setAttribute('aria-label', 'Indicatori multicolonna');

  const trackPaddingBottom = Number.parseFloat(window.getComputedStyle(track).paddingBottom) || 0;
  controls.style.setProperty('--mobile-auto-column-controls-offset', `${12 - trackPaddingBottom}px`);

  const controller = {
    section,
    track,
    slides,
    controls,
    dots: [],
    activeIndex: 0,
    scrollRafId: 0,
    autoplayIntervalId: 0,
    autoplayResumeTimeoutId: 0,
    onScroll: null,
    onInteraction: null,
    onVisibilityChange: null,
    isVisible: autoColumnRailObserver == null,
  };

  controller.dots = slides.map((_, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = AUTO_COLUMN_DOT_CLASS;
    dot.setAttribute('aria-label', `Vai alla colonna ${index + 1}`);
    dot.setAttribute('aria-current', 'false');

    dot.addEventListener('click', () => {
      pauseAutoColumnRailAutoplay(controller);
      scrollAutoColumnRailToIndex(controller, index);
    });

    controls.appendChild(dot);
    return dot;
  });

  controller.activeIndex = getCenteredSlideIndex(track, slides);

  controller.onScroll = () => {
    updateAutoColumnRailActiveFromScroll(controller);
  };

  controller.onInteraction = () => {
    pauseAutoColumnRailAutoplay(controller);
  };

  controller.onVisibilityChange = () => {
    if (document.hidden) {
      clearAutoColumnRailAutoplayInterval(controller);
      clearAutoColumnRailAutoplayResumeTimeout(controller);
      return;
    }

    startAutoColumnRailAutoplay(controller);
  };

  track.addEventListener('scroll', controller.onScroll, { passive: true });
  track.addEventListener('pointerdown', controller.onInteraction, { passive: true });
  track.addEventListener('touchstart', controller.onInteraction, { passive: true });
  track.addEventListener('wheel', controller.onInteraction, { passive: true });
  document.addEventListener('visibilitychange', controller.onVisibilityChange);

  controlsHost.appendChild(controls);
  autoColumnRailControllers.set(section, controller);
  autoColumnRailObserver?.observe(section);

  setAutoColumnRailActiveDot(controller, 0);
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      if (autoColumnRailControllers.get(section) !== controller) return;
      scrollAutoColumnRailToIndex(controller, 0, 'auto');

      if (controller.isVisible) {
        startAutoColumnRailAutoplay(controller);
      }
    });
  });
}

function setupAutoColumnRails() {
  destroyAutoColumnRails();

  const sections = document.querySelectorAll(`.${AUTO_COLUMN_RAIL_TAG_CLASS}`);
  for (const section of sections) {
    setupAutoColumnRail(section);
  }
}

// Imposta sizes corretto su mobile per forzare immagini a risoluzione adeguata.
function overrideMobileImageSizes() {
  const selectors = [
    '.mobile-home-products-rail img.image-block__image',
    '.mobile-home-hero-cards-rail img.image-block__image',
    '.mobile-page-menu-hero-cards-rail img.image-block__image',
    '.mobile-home-bottom-collections .resource-list.resource-list__carousel img.image-block__image',
    '.mobile-mirtillo-top-collections .resource-list.resource-list__carousel img.image-block__image',
    '.mobile-mirtillo-image-carousel .media-card-gallery__image',
    '.mobile-mirtillo-multicolumn-rail img.image-block__image',
    '.mobile-miele-multicolumn-rail img.image-block__image',
    '.mobile-laboratorio-quadrati-rail img.image-block__image',
    '.mobile-oliva-multicolumn-rail img.image-block__image',
    '.mobile-agrivoltaico-multicolumn-rail img.image-block__image',
    '.mobile-produzione-piante-quadrati-rail img.image-block__image',
    '.mobile-agrivoltaico-home-quadrati-rail img.image-block__image',
    '.mobile-appartamenti-quadrati-rail img.image-block__image',
    '.mobile-shop-multicolumn-rail img.image-block__image',
    '.mobile-auto-column-rail img.image-block__image',
    '.mobile-shop-product-list-single .resource-list.resource-list__carousel img.image-block__image',
  ];

  const images = document.querySelectorAll(selectors.join(','));

  for (const image of images) {
    if (!(image instanceof HTMLImageElement)) continue;

    if (image.dataset.mobileViewsSizesStored !== 'true') {
      const originalSizes = image.getAttribute('sizes');
      image.dataset.mobileViewsOriginalSizes = originalSizes ?? '__NONE__';
      image.dataset.mobileViewsSizesStored = 'true';
    }

    let nextSizes = MOBILE_IMAGE_SIZES;

    if (image.closest(`.${HOME_HERO_CARDS_TAG_CLASS}, .${PAGE_MENU_HERO_CARDS_TAG_CLASS}`)) {
      const isCompactPageMenu =
        image.closest(`.${PAGE_MENU_HERO_CARDS_TAG_CLASS}`) &&
        [MIRTILLO_PAGE_TEMPLATE, MIELE_PAGE_TEMPLATE, OLIVA_PAGE_TEMPLATE].includes(getCurrentTemplateName());

      nextSizes = isCompactPageMenu ? MOBILE_COMPACT_PAGE_MENU_IMAGE_SIZES : MOBILE_HERO_CARD_IMAGE_SIZES;
    }

    image.setAttribute('sizes', nextSizes);
  }
}

// Ripristina il valore sizes originale quando non si e' su mobile.
function restoreImageSizes() {
  const images = document.querySelectorAll('img[data-mobile-views-sizes-stored="true"]');

  for (const image of images) {
    if (!(image instanceof HTMLImageElement)) continue;

    const originalSizes = image.dataset.mobileViewsOriginalSizes;

    if (originalSizes === '__NONE__') {
      image.removeAttribute('sizes');
    } else if (originalSizes != null) {
      image.setAttribute('sizes', originalSizes);
    }

    delete image.dataset.mobileViewsOriginalSizes;
    delete image.dataset.mobileViewsSizesStored;
  }
}

function extractLinesFromElement(element) {
  const lines = [''];

  function walk(node) {
    if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'BR') {
      lines.push('');
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      lines[lines.length - 1] += node.textContent ?? '';
      return;
    }

    for (const child of node.childNodes) {
      walk(child);
    }
  }

  walk(element);

  return lines.map((line) => line.replace(/\s+/g, ' ').trim()).filter(Boolean);
}

function parseNutritionLine(line) {
  const normalizedLine = line.replace(/\s+/g, ' ').trim();

  for (const label of PRODUCT_NUTRITION_LABELS) {
    const prefix = `${label} `;

    if (!normalizedLine.startsWith(prefix)) continue;

    const value = normalizedLine.slice(prefix.length).trim();
    if (!value) return null;

    return { label, value };
  }

  return null;
}

function createNutritionTable(rows) {
  const table = document.createElement('dl');
  table.className = 'zilius-nutrition-table';

  for (const row of rows) {
    const item = document.createElement('div');
    item.className = 'zilius-nutrition-row';

    const label = document.createElement('dt');
    label.textContent = row.label;

    const value = document.createElement('dd');
    value.textContent = row.value;

    item.append(label, value);
    table.appendChild(item);
  }

  return table;
}

function formatProductNutritionTables() {
  if (!window.matchMedia(MOBILE_BREAKPOINT).matches) return;

  const textBlocks = document.querySelectorAll(PRODUCT_NUTRITION_TEXT_SELECTOR);

  for (const textBlock of textBlocks) {
    if (!(textBlock instanceof HTMLElement)) continue;
    if (textBlock.dataset.mobileViewsNutritionReady === 'true') continue;

    const firstParagraph = Array.from(textBlock.children).find((child) => child instanceof HTMLParagraphElement);
    if (!firstParagraph) continue;

    const rows = extractLinesFromElement(firstParagraph).map(parseNutritionLine).filter(Boolean);
    if (rows.length < 2 || !rows.some((row) => row.label === 'Energia')) continue;

    textBlock.dataset.mobileViewsNutritionOriginalHtml = textBlock.innerHTML;
    firstParagraph.replaceWith(createNutritionTable(rows));

    for (const child of textBlock.children) {
      if (child instanceof HTMLParagraphElement) {
        child.classList.add('zilius-nutrition-note');
      }
    }

    textBlock.dataset.mobileViewsNutritionReady = 'true';
  }
}

function restoreProductNutritionTables() {
  const textBlocks = document.querySelectorAll('[data-mobile-views-nutrition-ready="true"]');

  for (const textBlock of textBlocks) {
    if (!(textBlock instanceof HTMLElement)) continue;

    const originalHtml = textBlock.dataset.mobileViewsNutritionOriginalHtml;
    if (originalHtml != null) {
      textBlock.innerHTML = originalHtml;
    }

    delete textBlock.dataset.mobileViewsNutritionOriginalHtml;
    delete textBlock.dataset.mobileViewsNutritionReady;
  }
}

function queueProductNutritionTableFormatting() {
  formatProductNutritionTables();
  window.setTimeout(formatProductNutritionTables, 250);
  window.setTimeout(formatProductNutritionTables, 1000);
}

// Ripristina il layout originale quando si esce dal mobile.
function restoreOriginalLayout() {
  clearHeroMenuActiveAlignQueue();
  destroyHomeProductsCarousel();
  destroyAutoColumnRails();

  if (!state.applied) return;

  state.movedCards.forEach((card, index) => {
    const marker = state.placeholders[index];
    if (!marker || !marker.parentNode) return;
    marker.parentNode.insertBefore(card, marker);
    marker.remove();
  });

  if (state.firstSection) {
    state.firstSection.classList.remove('mobile-home-products-rail');
  }

  if (state.firstTrack) {
    state.firstTrack.classList.remove('mobile-home-products-track');
    if (state.firstHadMobileColumn) {
      state.firstTrack.classList.add('mobile-column');
    }
  }

  if (state.secondSection) {
    state.secondSection.classList.remove('mobile-home-products-source-hidden');
  }

  state.applied = false;
  state.firstSection = null;
  state.secondSection = null;
  state.firstTrack = null;
  state.movedCards = [];
  state.placeholders = [];
  state.firstHadMobileColumn = false;
}

// Aggiorna il layout in base al breakpoint corrente.
function syncMobileProductsLayout() {
  markBottomHomeCollectionCarousel();
  markHomeHeroCardsRail();
  markPageMenuHeroCardsRail();
  markHeroMenuActiveCards();
  markMirtilloTopCollectionsCarousel();
  markMirtilloMulticolumnRails();
  markMieleMulticolumnRails();
  markOlivaMulticolumnRails();
  markAgrivoltaicoMulticolumnRails();
  markAppartamentiQuadratiRails();
  markAgrivoltaicoHomeQuadratiRails();
  markLaboratorioQuadratiRails();
  markProduzionePianteQuadratiRails();
  markShopMulticolumnRails();
  markShopProductListCarousel();
  setupShopProductFilter();
  markMirtilloMediaGallery();
  markAutoColumnRails();

  const isMobile = window.matchMedia(MOBILE_BREAKPOINT).matches;

  if (isMobile) {
    applyMobileProductsRail();
    setupHomeProductsCarousel();
    setupAutoColumnRails();
    overrideMobileImageSizes();
    queueProductNutritionTableFormatting();
    queueHeroMenuActiveAlign();
  } else {
    restoreOriginalLayout();
    restoreImageSizes();
    restoreProductNutritionTables();
  }
}

const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);

if (typeof mediaQuery.addEventListener === 'function') {
  mediaQuery.addEventListener('change', syncMobileProductsLayout);
} else {
  mediaQuery.addListener(syncMobileProductsLayout);
}

// Re-applica la logica quando Shopify ricarica sezioni in editor.
document.addEventListener('click', handleShopProductFilterClick);
function handleShopFilterSectionChange() {
  restoreShopFilterGrid();
  state.shopFilterCategory = null;
  syncMobileProductsLayout();
}

document.addEventListener('shopify:section:load', handleShopFilterSectionChange);
document.addEventListener('shopify:section:unload', handleShopFilterSectionChange);
document.addEventListener('shopify:section:reorder', handleShopFilterSectionChange);

const shopFilterObserver =
  typeof MutationObserver === 'function'
    ? new MutationObserver((mutations) => {
        if (!isShopTemplate()) return;

        const hasRelevantChange = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) =>
              node instanceof Element &&
              (node.matches?.(`.${SHOP_FILTER_TRIGGER_CLASS}, .${SHOP_FILTER_ITEM_CLASS}, .group-block`) ||
                node.querySelector?.(`.${SHOP_FILTER_TRIGGER_CLASS}, .${SHOP_FILTER_ITEM_CLASS}, .group-block`)),
          ),
        );

        if (hasRelevantChange) {
          queueShopProductFilterSetup();
        }
      })
    : null;

function observeShopProductFilterDom() {
  if (!isShopTemplate() || !shopFilterObserver || !document.body) return;

  shopFilterObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Primo avvio.
if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      observeShopProductFilterDom();
      syncMobileProductsLayout();
    },
    { once: true },
  );
} else {
  observeShopProductFilterDom();
  syncMobileProductsLayout();
}
